document.addEventListener('DOMContentLoaded', () => {
    const panels = document.querySelectorAll('.ctn_footer .top_ctn .ctn_links .links ul');
    const triggers = document.querySelectorAll('.ctn_footer .top_ctn .ctn_links .links .tlt');
    
    let isInitialized = false;
    let resizeTimeout;

    /**
     * @param {Element} panel
     */
    function closePanel(panel) {
        const el = panel instanceof HTMLElement ? panel : null;
        if (!el) return;
        
        el.classList.remove('open');
        el.style.maxHeight = '0px';
    }

    /**
     * @param {Element} panel
     */
    function openPanel(panel) {
        const el = panel instanceof HTMLElement ? panel : null;
        if (!el) return;
        
        // Primero establecer maxHeight a auto para medir
        el.style.maxHeight = 'auto';
        const fullHeight = el.scrollHeight;
        
        // Resetear a 0 para la animación
        el.style.maxHeight = '0px';
        
        // Forzar reflow
        void el.offsetHeight;
        
        // Agregar clase y animar
        el.classList.add('open');
        el.style.maxHeight = fullHeight + 'px';
        
        // Después de la transición, establecer a auto para contenido dinámico
        setTimeout(() => {
            if (el.classList.contains('open')) {
                el.style.maxHeight = 'auto';
            }
        }, 450); // Duración de la transición CSS
    }

    function isMobile() {
        return window.innerWidth <= 768;
    }

    function removeAllEventListeners() {
        // Clonar elementos para remover todos los event listeners
        triggers.forEach((trigger, idx) => {
            const newTrigger = trigger.cloneNode(true);
            trigger.parentNode.replaceChild(newTrigger, trigger);
        });
    }

    function initializeMobileAccordion() {
        if (!isMobile()) return;
        
        // Configurar estado inicial para móviles
        panels.forEach(panel => {
            panel.style.maxHeight = '0px';
            panel.classList.remove('open');
        });
        
        triggers.forEach(trigger => {
            trigger.classList.remove('is-open');
        });
    }

    function setupAccordion() {
        const currentTriggers = document.querySelectorAll('.ctn_footer .top_ctn .ctn_links .links .tlt');
        
        if (!isMobile()) {
            // Reset accordion state for desktop
            panels.forEach(panel => {
                panel.classList.remove('open');
                panel.style.maxHeight = '';
            });
            currentTriggers.forEach(trigger => {
                trigger.classList.remove('is-open');
                // Remover event listeners en desktop
                const newTrigger = trigger.cloneNode(true);
                trigger.parentNode.replaceChild(newTrigger, trigger);
            });
            isInitialized = false;
            return;
        }

        // Solo inicializar una vez en móviles
        if (isInitialized) return;
        
        initializeMobileAccordion();

        currentTriggers.forEach((trigger, idx) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const panel = panels[idx];
                if (!panel) return;

                const isOpen = panel.classList.contains('open');

                // Cerrar todos los otros paneles
                panels.forEach((p, pIdx) => {
                    if (p !== panel && p.classList.contains('open')) {
                        closePanel(p);
                        currentTriggers[pIdx]?.classList.remove('is-open');
                    }
                });

                if (isOpen) {
                    closePanel(panel);
                    trigger.classList.remove('is-open');
                } else {
                    openPanel(panel);
                    trigger.classList.add('is-open');
                }
            });
        });
        
        isInitialized = true;
    }

    // Configurar acordeón inicialmente
    setupAccordion();

    // Debounced resize handler
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const wasMobile = isInitialized;
            const nowMobile = isMobile();
            
            if (wasMobile !== nowMobile) {
                isInitialized = false;
                setupAccordion();
            }
            
            // Ajustar heights si estamos en móvil y hay paneles abiertos
            if (nowMobile) {
                panels.forEach(panel => {
                    if (panel.classList.contains('open')) {
                        panel.style.maxHeight = 'auto';
                        const fullHeight = panel.scrollHeight;
                        panel.style.maxHeight = fullHeight + 'px';
                    }
                });
            }
        }, 100);
    }

    window.addEventListener('resize', handleResize);

    // ==============================
    // Reemplazar botón newsletter (Klaviyo) por SVG personalizado
    // ==============================
    (function replaceFooterNewsletterBtn() {
        // Selector específico que diste (quitando el doble button redundante al final)
        const RAW_SELECTOR = '.ctn_footer .top_ctn .newsletter .ctn_input form > .needsclick > .needsclick > .needsclick:nth-child(2) button';
        // Fallback más genérico (por si cambia la estructura de Klaviyo)
        const FALLBACK_SELECTOR = '.ctn_footer .top_ctn .newsletter .ctn_input form button[type="submit"], .ctn_footer .top_ctn .newsletter .ctn_input form button';

        const svgMarkup = `
           <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.681641 23.9997C0.681641 11.0743 11.1598 0.596191 24.0852 0.596191C37.0106 0.596191 47.4887 11.0743 47.4887 23.9997C47.4887 36.9251 37.0106 47.4032 24.0852 47.4032C11.1598 47.4032 0.681641 36.9251 0.681641 23.9997ZM32.5651 24.7794H13.7229V23.2204H32.5647L25.74 16.3958L26.8425 15.2934L34.998 23.4489L35.5492 24.0001L34.998 24.5513L26.8425 32.7068L25.74 31.6044L32.5651 24.7794Z" fill="#FAF9F6"/>
            </svg>
        `
        /**
         * Intenta localizar el botón y reemplazar su contenido.
         * @returns {boolean}
         */
        const apply = () => {
            /** @type {HTMLElement|null} */
            let btn = document.querySelector(RAW_SELECTOR);
            if (!btn) {
                btn = document.querySelector(FALLBACK_SELECTOR);
            }
            if (!btn) return false;

            // Si dentro hay otro button anidado (doble button), usar el más interno
            const innerBtn = btn.querySelector('button');
            if (innerBtn instanceof HTMLElement) {
                btn = innerBtn;
            }

            if (btn.dataset.footerSvgReplaced === 'true') return true;

            // Limpia y añade SVG
            btn.innerHTML = svgMarkup;
            btn.dataset.footerSvgReplaced = 'true';
            btn.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Submit');
            btn.style.display = 'flex';
            btn.style.alignItems = 'center';
            btn.style.justifyContent = 'center';
            btn.style.padding = '0';

            // Observer para mantener el SVG si Klaviyo re-renderiza
            const guard = new MutationObserver(() => {
                if (!btn.innerHTML.includes('<svg')) {
                    btn.innerHTML = svgMarkup;
                }
            });
            guard.observe(btn, { childList: true, subtree: true });
            // Guardar referencia para depuración
            btn.dataset.footerSvgObserver = 'active';

            return true;
        };

        if (apply()) return; // Ya estaba disponible

        // Observar inyección asíncrona de Klaviyo
        const globalObserver = new MutationObserver(() => {
            if (apply()) {
                globalObserver.disconnect();
            }
        });
        globalObserver.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => globalObserver.disconnect(), 15000); // Seguridad
    })();

    // botton_ctn--product_page

    const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
    const bottomCtn = document.querySelector('.ctn_footer .botton_ctn');

    if (stickyAddToCart && window.location.pathname.includes('/products/') && bottomCtn) {
        bottomCtn.classList.add('botton_ctn--product_page');
    }
});